import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Icon, Table, UserManual } from "../../../../components";
import { Box } from "../../../../components/box-v2";
import { RequestStatus } from "../../../../constants";
import { SEARCH_PARAMS } from "../../../../constants/searchParams";
import { useUser } from "../../../../hook";
import { useSearchParams } from "../../../../hook/use-search-params";
import SelectStatusParam, {
  APPROVED_STATUS,
  PENDING_STATUS,
  REJECTED_STATUS,
  REVOKED_STATUS,
} from "./components/select-status-param";
import { useAFLColumns, useAFLRequests } from "./hooks";
import { AFLType } from "./models";
import convertStatus from "./utils/convertStatus";

const AbsenceLetter = withProcedureWraper(() => {
  const history = useHistory();

  const { columns } = useAFLColumns();
  const { isLoading, myDefaultRequests, defaultRequestsNeedApproval } = useAFLRequests({
    aflType: AFLType.ApplicationForLeave,
    department: ["TSN", "KCQ"],
  });
  const { checkCurrentUser } = useUser();

  const { searchParams } = useSearchParams();
  const status = searchParams.get(SEARCH_PARAMS.status) || PENDING_STATUS;
  const myStatus = searchParams.get(SEARCH_PARAMS.myStatus);

  const myFilteredRequest = useMemo(() => {
    if (!myStatus) return myDefaultRequests;

    const filtered = myDefaultRequests.filter((request: any) => {
      const steps = request.eSteps;

      if (!steps.length) return false;

      const isCreator = checkCurrentUser(steps[0][0].email);

      if (isCreator) {
        if (myStatus === PENDING_STATUS) return request.eRequestStatus === RequestStatus.submitted;
        if (myStatus === APPROVED_STATUS) return request.eRequestStatus === RequestStatus.completed;
        if (myStatus === REJECTED_STATUS) return request.eRequestStatus === RequestStatus.rejected;
        if (myStatus === REVOKED_STATUS) return request.eRequestStatus === RequestStatus.revoked;
        return false;
      }

      return false;
    });

    return filtered;
  }, [myStatus, myDefaultRequests, checkCurrentUser]);

  const needApprovalFilteredRequest = useMemo(() => {
    if (!status) return defaultRequestsNeedApproval;

    const filtered = defaultRequestsNeedApproval.filter((request: any) => {
      const steps = request.eSteps;

      if (!steps.length) return false;

      return steps.some((step: any[]) =>
        step.some(
          (item: any) =>
            checkCurrentUser(item.email) &&
            (status === PENDING_STATUS
              ? (!item.histories || item.histories.length === 0) && request.eRequestStatus === RequestStatus.submitted
              : item.histories.some(
                  (history: any) =>
                    convertStatus(history.status) === REJECTED_STATUS ||
                    convertStatus(history.status) === APPROVED_STATUS,
                )),
        ),
      );
    });

    return filtered;
  }, [checkCurrentUser, defaultRequestsNeedApproval, status]);

  const redirectToDetailPage = (requestId: string) => {
    history.push(`${Routes.absenceLetterPage.path}/${requestId}`);
  };

  // const redirectToCreatePage = () => {
  //   history.push(Routes.createAbsenceLetterPage.path);
  // };

  return (
    <div className="pd15">
      <UserManual
        icon={<Icon.DocumentWrite />}
        title="ĐƠN XIN NGHỈ PHÉP"
        guideLink="https://drive.google.com/file/d/16RrfCW4U_z5SCJnbRmjKxFusx48wtRWA/view?usp=drive_link"
      />
      {/* <Box title="Yêu cầu đã duyệt" titleRight={<CreateRequestButton onClick={redirectToCreatePage} />}>
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns2}
          dataSource={completedMyTSNRequests}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: "max-content" }}
        />
      </Box>
      <Box title="Yêu cầu cần duyệt">
        <Table
          bordered
          rowKey="id"
          loading={isLoading}
          columns={columns2}
          dataSource={myRequestsNeedApproval}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: "max-content" }}
        />
      </Box> */}
      <Box
        collapsible
        title="Yêu cầu của tôi"
        titleRight={
          <div className="flex items-center gap-2">
            <SelectStatusParam showRevoked paramKey={SEARCH_PARAMS.myStatus} />

            {/* <CreateRequestButton onClick={redirectToCreatePage} /> */}
          </div>
        }
      >
        <div className={!myFilteredRequest?.length ? "hide-table-body-wrapper" : undefined}>
          <Table
            bordered
            rowKey="id"
            loading={isLoading}
            columns={columns}
            dataSource={myFilteredRequest}
            onRow={(record: any) => ({
              onClick: () => redirectToDetailPage(record.id),
              style: { cursor: "pointer" },
            })}
            scroll={{ x: "max-content" }}
          />
        </div>
      </Box>

      <Box
        collapsible
        title="Yêu cầu cần duyệt"
        titleRight={
          <div className="flex items-center gap-2">
            <SelectStatusParam defaultValue={PENDING_STATUS} />
          </div>
        }
      >
        <div className={!needApprovalFilteredRequest?.length ? "hide-table-body-wrapper" : undefined}>
          <Table
            bordered
            rowKey="id"
            loading={isLoading}
            columns={columns}
            dataSource={needApprovalFilteredRequest}
            onRow={(record: any) => ({
              onClick: () => redirectToDetailPage(record.id),
              style: { cursor: "pointer" },
            })}
            scroll={{ x: "max-content" }}
          />
        </div>
      </Box>
    </div>
  );
});

export default AbsenceLetter;
